import { Box, Flex } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

interface ContentWrapperProps {
  aside: JSX.Element | null;
}

const ContentWrapper: FCWithChildren<ContentWrapperProps> = ({
  aside,
  children,
}) => (
  <Box paddingBottom="space-64">
    <Flex>
      {aside ?? null}
      <Box flexGrow={1}>{children}</Box>
    </Flex>
  </Box>
);

export default ContentWrapper;
